<div class="yc-layout yc-layout-login flex-column justify-content-between">
  <div></div>

  <yc-form *ngIf="!loggingInWithSSO &&
    !showConvertToBbidText"
    [formGroup]="formGroup"
    [formSubmit]="_onSubmit">
    <div *ngIf="isApply">
      <h1 class="applicant-portal-header">
        <yc-i18n
        key="common:hdrApplicantPortal"
        defaultValue="Applicant Portal">
      </yc-i18n>
      </h1>
    </div>
    <!-- Header -->
    <yc-panel
      [type]="PanelTypes.FormSectionHeader"
      [isFirst]="true"
      [title]="'AUTH:hdrLogin' | ycI18n: 'ENTER YOUR ACCOUNT DETAILS BELOW'">
    </yc-panel>

    <!-- Email -->
    <div class="mb-3">
      <yc-input
        name="username"
        [label]="'GLOBAL:textEmailAddress' | ycI18n:'Email address'"
        [autofocus]="true"
        type="email"
        (onChange)="setUsername($event)">
      </yc-input>
    </div>

    <!-- Remember Me -->
    <div class="mt-3">
      <yc-checkbox
        name="rememberMe"
        [optionLabel]="'AUTH:checkRemember' | ycI18n: 'Remember me'"
        (onChange)="rememberMeChange($event)">
      </yc-checkbox>
    </div>

    <!-- Sign In -->
    <div class="d-flex align-items-center justify-content-end mobile-mb-100 mt-3">
      <!-- Help -->
      <ng-container *ngIf="!isApply">
        <ng-template *ngTemplateOutlet="helpButton"></ng-template>
      </ng-container>
    
      <yc-button *ngIf="!!ssoLoginUrl"
        class="me-2"
        [secondary]="true"
        [langKey]="'AUTH:btnSignInWithSSO'"
        [defaultText]="'Sign in with SSO'"
        (onClick)="loginWithSSO()">
      </yc-button>
      <yc-submit>
        <yc-i18n
          key="AUTH:textSignIn"
          defaultValue="Sign in">
        </yc-i18n>
      </yc-submit>
    </div>
  </yc-form>

  <!-- SSO Login -->
  <div *ngIf="loggingInWithSSO">
    <yc-panel
      [type]="PanelTypes.FormSectionHeader"
      [isFirst]="true"
      [title]="'AUTH:hdrSigningInWithSSO' | ycI18n: 'SIGNING IN WITH SSO...'">
    </yc-panel>
  </div>

  <!-- Convert to BBID  -->
  <div *ngIf="showConvertToBbidText"
    class="ms-5 me-5">
    <div>
      <yc-panel
        [type]="PanelTypes.FormSectionHeader"
        [isFirst]="true"
        [title]="'AUTH:textConvertYourAccountToBbid' | ycI18n: 'Convert your account to BBID'">
      </yc-panel>
    </div>
    <div class="mb-4">
      <yc-i18n
        key="AUTH:textConvertYourAccountToBbidDesc"
        defaultValue="GrantsConnect is now using Blackbaud ID (BBID) to sign in. Select continue to convert your account to BBID.">
      </yc-i18n>
      
      <div
        [innerHTML]="'AUTH:textLearnMoreBbidHelp' | ycI18n: bbidHelpText: {
          helpCenterLink
        }"
        class="mt-2">
      </div>
    </div>

    <!-- Continue to BBID -->
    <yc-button *ngIf="showConvertToBbidText"
      class="d-flex justify-content-end"
      [primary]="true"
      [langKey]="'common:textContinue'"
      [defaultText]="'Continue'"
      (onClick)="continueToBbid()">
    </yc-button>
  </div>


  <!-- Actions -->
  <div class="login-actions">
    <ng-container *ngIf="!loggingInWithSSO &&
      !showConvertToBbidText">

      <!-- Help -->
      <ng-container *ngIf="isApply">
        <ng-template *ngTemplateOutlet="helpButton"></ng-template>
      </ng-container>

      <!-- Create Account -->
      <yc-button *ngIf="isApply"
        [link]="true"
        [langKey]="'AUTH:textCreateAccount'"
        [defaultText]="'Create account'"
        (onClick)="createAccount()">
      </yc-button>
    </ng-container>
  </div>
</div>





<ng-template #helpButton>
  <!-- Help -->
  <yc-button
    class="me-2"
    [link]="true"
    [langKey]="'common:NeedHelpSigningIn'"
    [defaultText]="'Need help signing in'"
    (onClick)="openHelpLink()">
  </yc-button>
</ng-template>